import React from 'react'
import PropTypes from 'prop-types'
import { THREE_STEPPER_HEADER_TITLE } from './constants'
import StepperHeader from './components/StepperHeader'
import RequestSentBlockNew from './components/RequestSentBlockNew'
import RequestSentBlock from './components/RequestSentBlock'

const StepperContainer = ({
  steps,
  currentStepIndex,
  setCurrentStepIndex,
  isDone,
  Component,
  content,
  appointmentResponse,
  prevPageClick,
  nextPageClick,
  threeStepperEnabled,
  dateTimeStepIndex,
  beforeNavigatingToDateTimeStep,
  title,
  isE2EAppointment,
  isPilotStore,
  ...props
}) => {
  const renderQuickAppointment = () => {
    // For pilot stores show newly designed quick appointment page otherwise show the old one.
    if (isPilotStore) {
      return <RequestSentBlockNew />
    }
    return <RequestSentBlock isE2EAppointment={ isE2EAppointment } />
  }

  return (
    appointmentResponse
      ? renderQuickAppointment()
      : <React.Fragment>
        <StepperHeader
          threeStepperEnabled={ threeStepperEnabled }
          steps={ steps }
          currentStepIndex={ currentStepIndex }
          setCurrentStepIndex={ setCurrentStepIndex }
          title={ threeStepperEnabled ? title : THREE_STEPPER_HEADER_TITLE }
          beforeNavigatingToDateTimeStep={ beforeNavigatingToDateTimeStep }
          dateTimeStepIndex={ dateTimeStepIndex }
          isE2EAppointment={ isE2EAppointment } />

        <Component
          isDone={ isDone }
          isE2EAppointment={ isE2EAppointment }
          currentStepIndex={ currentStepIndex }
          setCurrentStepIndex={ setCurrentStepIndex }
          nextPageClick={ nextPageClick }
          beforeNavigatingToDateTimeStep={ beforeNavigatingToDateTimeStep }
          onPrevPage={ prevPageClick }
          onSubmit={ nextPageClick }
          { ...props } >
          { content }
        </Component>
      </React.Fragment>
  )
}

export default StepperContainer

StepperContainer.propTypes = {
  appointmentResponse: PropTypes.shape({}),
  beforeNavigatingToDateTimeStep: PropTypes.func,
  Component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  currentStepIndex: PropTypes.number,
  dateTimeStepIndex: PropTypes.number,
  isDone: PropTypes.bool,
  isE2EAppointment: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  nextPageClick: PropTypes.func,
  prevPageClick: PropTypes.func,
  setCurrentStepIndex: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.shape()),
  threeStepperEnabled: PropTypes.bool,
  title: PropTypes.string
}
